export default {
	linkSelectors: [
		"div.navbar-header:not(.disabled) a.navbar-brand",
		'ul.navbar-nav a:not(.disabled):not([href="javascript:;"])',
		'.BottomNav__main-nav a:not(.disabled):not([href="javascript:;"])',
		'.SideNav__content a[data-remote]:not([data-toggle="modal"])',
	],
	navsSelector: "nav.navbar, .BottomNav, .SideNav__content",
	topNavSelector: "nav.navbar",
	bottomNavSelector: ".BottomNav",
	sideNavElemSelector: ".SideNav__group:not(.SideNav__group--bottom)",
	trayTriggerSelector: ".BottomNav__main-nav--tray-toggle",
	traySelector: ".BottomNav__main-nav--tray",
	progressDataElSelector: "body",
	bottomNavOverflowItemsContainerSelector: ".BottomNav__main-nav--tray",

	oneOffHints: [
		// {
		// 	name: 'mobile_nav_is_here',
		// 	attachedTo: '.navbar-toggle',
		// 	breakpointCondition: '<gridFloatBreakpoint',
		// 	animationClasses: 'animated animated-slower infinite pulse',
		// 	//popover: {
		// 	//placement: 'bottom',
		// 	//trigger: 'manual',
		// 	//content: I18n.t('global.navigation'),
		// 	//template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>'
		// 	//},
		// 	dismissEvent: 'click',
		// 	dismissTarget: '.navbar-toggle, .navbar-brand'
		// }
	],

	isLoading() {
		return (
			$(pp.navigation.progressDataElSelector).attr(
				"data-in-page-loading-progress",
			) !== undefined
		);
	},

	setLoadingData($clickedEl) {
		$(pp.navigation.progressDataElSelector).attr(
			"data-in-page-loading-progress",
			$clickedEl.attr("href"),
		);
	},

	resetLoadingState() {
		$(pp.navigation.progressDataElSelector).removeAttr(
			"data-in-page-loading-progress",
		);
	},

	isLoadingDifferentPage($navItem) {
		return (
			pp.navigation.isLoading() &&
			$(pp.navigation.progressDataElSelector).attr(
				"data-in-page-loading-progress",
			) != $navItem.attr("href")
		);
	},

	initGlobalListeners() {
		pp.navigation.initLinkManagement();
		$(document).on("click", pp.navigation.trayTriggerSelector, () => {
			$(pp.navigation.bottomNavSelector).toggleClass("BottomNav--tray-open");
		});

		const $navbar = $(".navbar-collapse");
		const $mobileTopNavBackdrop = $(
			'<div class="navbar-collapse-backdrop fade"></div>',
		);
		// collapse mobile top nav when clicking outside of it.
		$navbar.on("show.bs.collapse", () => {
			const $appendedBackdrop = $mobileTopNavBackdrop.clone().appendTo("body");
			$appendedBackdrop.addClass("in"); // Trigger fading in
		});
		$navbar.on("hide.bs.collapse", () => {
			$(".navbar-collapse-backdrop").remove();
		});
		$(document).on("click", ".navbar-collapse-backdrop", (e) => {
			// @ts-expect-error
			$navbar.collapse("hide");
		});
	},

	initLinkManagement() {
		// Set navigation link active as soon as user clicks it (for ajax-requests).
		// Block triggering of other navigation links while one is still loading
		$(document).on("click", pp.navigation.linkSelectors.join(", "), (event) => {
			const module = pp.navigation;
			const $link = $(event.currentTarget);
			pp.log("NAVIGATION click -- event", event, this);

			if (
				$link.parent().hasClass("dropdown") ||
				module.isLoadingDifferentPage($link)
			) {
				return;
			}

			if ($link.parents(".BottomNav__main-nav--tray").length) {
				// pp.log("NAVIGATION Click", event, $link)
				module.swapActiveOverflowNavItem($link);
			} else if (
				$(".BottomNav__main-nav--tray").find(`a[href='${$link.attr("href")}']`)
					.length
			) {
				// Swap the bottom menu item from the tray even if the top nav item has been clicked
				module.swapActiveOverflowNavItem(
					$(".BottomNav__main-nav--tray").find(
						`a[href='${$link.attr("href")}']`,
					),
				);
			}

			// Imediately hide the sub nav
			if ($link.parents(".BottomNav__main-nav").length) {
				$(module.bottomNavSelector).removeClass("BottomNav--with-sub-nav");
			}
			pp.navigation.setNewNavItemActive($link.attr("href"));
		});

		$(document).on(
			"ajax:beforeSend",
			pp.navigation.linkSelectors.join(", "),
			(event) => {
				// pp.log("NAVIGATION Ajax beforeSend", event);
				if (pp.navigation.isLoading()) {
					// pp.log("NAVIGATION Ajax beforeSend isLoading()");
					event.preventDefault();
					event.stopImmediatePropagation();
					pp.navigation.loadProgressClearTimeout = setTimeout(
						pp.navigation.resetLoadingState,
						3000,
					);
					return false;
				}
				// else
				// @ts-expect-error
				Turbolinks.ProgressBar.start();
				pp.navigation.setLoadingData($(event.target));
			},
		);

		$(document).on(
			"ajax:complete",
			pp.navigation.linkSelectors.join(", "),
			() => {
				// pp.log("NAVIGATION Ajax:complete");
				// @ts-expect-error
				Turbolinks.ProgressBar.done();
				pp.navigation.resetLoadingState();
				$(pp.navigation.bottomNavSelector).removeClass("BottomNav--tray-open");
				$(pp.navigation.traySelector).removeClass("in");
				clearTimeout(pp.navigation.loadProgressClearTimeout);
				// Only do it when the bottom nav is visible
				if (pp.viewHelpers.isBreakpointOfSize("<=gridFloatBreakpoint")) {
					pp.viewHelpers.scrollToTop();
				}
				$("#chartjs-tooltip").remove(); // Was appended to the end of the body and not removed between nav via menu causing inconsistent page heights
			},
		);

		$(document).on("page:change", pp.navigation.setNewNavItemActive);
	},

	setNewNavItemActive: (pathName) => {
		const module = pp.navigation;
		// `pathName` might be an an event object
		if (!pathName || typeof pathName !== "string") {
			pathName = window.location.pathname;
		}
		// pp.log("into setNewNavItemActive -- pathName", pathName);
		if (
			window.location.pathname ==
			$(module.progressDataElSelector).attr("data-in-page-loading-progress")
		) {
			// pp.log("is loading from nav");
			return;
		}

		const linkSelectorsWithHref = module.linkSelectors
			.map((selector) => {
				return `${selector}[href='${pathName}']`;
			})
			.join(", ");
		const $links = $(linkSelectorsWithHref);
		if (!$links.length) {
			return;
		}
		// $link.parents(module.sideNavElemSelector).addClass('active'); // Only for the side nav
		const $nonDropdownParent = $links.parent(
			"li:not(.dropdown):not(.active), .navbar-header:not(.active)",
		);
		let $sideNavParents = $links
			.parents(module.sideNavElemSelector)
			.not(".active");
		// pp.log("- $links, $nonDropdownParent, $sideNavParents", $links, $nonDropdownParent, $sideNavParents)
		if ($nonDropdownParent.length || $sideNavParents.length) {
			// Remove old active class
			$(module.navsSelector).find(".active").removeClass("active");
		}
		$nonDropdownParent.addClass("active");

		// The top-level nav item's `active` class might have been removed because it's included in the of the `navsSelector`
		$sideNavParents = $links.parents(module.sideNavElemSelector).not(".active");
		$sideNavParents.addClass("active");
	},

	initOneOffHints() {
		$.each(this.oneOffHints, (idx, hint) => {
			const breakpointMissmatch =
				// @ts-expect-error
				hint.breakpointCondition &&
				// @ts-expect-error
				!pp.viewHelpers.isBreakpointOfSize(hint.breakpointCondition);
			// @ts-expect-error
			const $hintTarget = $(hint.attachedTo);
			// pp.log("hint", hint, $hintTarget.data(), breakpointMissmatch);
			if (
				$hintTarget.data("hintDismissed") ||
				$hintTarget.data("bs.popover") ||
				breakpointMissmatch
			) {
				return;
			}
			// @ts-expect-error
			if (hint.popover) {
				// @ts-expect-error
				$hintTarget.popover(hint.popover).popover("show");
				// @ts-expect-error
			} else if (hint.animationClasses) {
				// @ts-expect-error
				$hintTarget.addClass(hint.animationClasses);
				setTimeout(() => {
					// @ts-expect-error
					$hintTarget.removeClass(hint.animationClasses);
				}, 7000);
			}
			const dismissFunction = () => {
				// @ts-expect-error
				$hintTarget.popover("destroy");
				// @ts-expect-error
				if (hint.animationClasses) {
					// @ts-expect-error
					$hintTarget.removeClass(hint.animationClasses);
				}

				$hintTarget.data("hintDismissed", true);
				$.post("/activities/save_tracked_information", {
					// @ts-expect-error
					dismissible_hint: hint.name,
				});
			};
			// @ts-expect-error
			$(document).one(hint.dismissEvent, hint.dismissTarget, dismissFunction);
		});
	},

	swapActiveOverflowNavItem($clickedEl) {
		const $moreEl = $(
			// @ts-expect-error
			$(
				".BottomNav .BottomNav__main-nav:not(.BottomNav__main-nav--tray) li",
			).get(4),
		);
		const $fourthEl = $(
			// @ts-expect-error
			$(
				".BottomNav .BottomNav__main-nav:not(.BottomNav__main-nav--tray) li",
			).get(3),
		);
		const $el = $clickedEl.parent("li");
		const animationDuration = 200;
		$el.addClass("animated fadeOutUp");
		// @ts-expect-error
		$fourthEl.addClass("animated fadeOutDown");
		$el.before($fourthEl);
		// @ts-expect-error
		$moreEl.before($el);
		setTimeout(() => {
			$el.removeClass("animated fadeOutUp");
			// @ts-expect-error
			$fourthEl.removeClass("animated fadeOutDown");
			$el.addClass("animated fadeInUp");
			// @ts-expect-error
			$fourthEl.addClass("animated fadeInDown");
		}, animationDuration);
	},
};
